import React from "react";
import Paper from "@material-ui/core/Paper";
import "../../admin/routes/setup/programme/table.css";
import AlbertLogo from "../../assets/images/StAlbertLogo.png";
//import LuminateLogo from "assets/images/sidmach-logo-A.png";
var LuminateLogo =
  "https://sidmach.com/wp-content/uploads/2024/02/sidmach-logo-A.png";

// This function is used to display the appliant form for usermode of applicant
const ApplicantForm = ({ applicant, olevel }) => {
  // debugger;
  // const { applicant, olevel } = this.state;
  // Function to handle DOB value
  const handleDobValue = (DateOfBirth) => {
    const myDate = new Date(DateOfBirth);
    const dayOfMonth = myDate.getDate();
    const month = myDate.getMonth();
    const year = myDate.getFullYear();
    if (myDate !== "") {
      return year + "-" + pad(month + 1) + "-" + pad(dayOfMonth);
    }
  };

  const pad = (n) => {
    return n < 10 ? "0" + n : n;
  };

  return (
    <>
      <Paper>
        <div id="content">
          <header className="mt-2" style={{ borderBottom: "1px solid gray" }}>
            <div className="container">
              <div className="row">
                <div className="col-lg-3">
                  <img
                    className="img-fluid"
                    src="https://pacademystore.blob.core.windows.net/logos/StAlbertLogo.png"
                    // src={AlbertLogo}
                    alt=""
                    style={{ maxWidth: "100px", maxHeight: "100px" }}
                  />
                </div>
                <div className="col-lg-9 flex-column align-self-end text-center">
                  <h1 style={{ color: "#093368", fontSize: "40px" }}>
                    <strong>St. Albert Institute, Fayit, Fadan-Kagoma</strong>
                    <br />
                  </h1>
                </div>
              </div>
            </div>
          </header>

          {/* Details Section */}
          <div className="container-fluid mb-5">
            <div className="column">
              <div className="col-lg-12 mt-3">
                <div className="col-lg-12 text-center mb-3">
                  <h3
                    className="p-3"
                    style={{
                      fontSize: "2em",
                      fontWeight: "bold",
                      borderRadius: "6px",
                    }}
                  >
                    PROSPECTIVE STUDENT APPLICATION SLIP
                  </h3>
                </div>
              </div>
            </div>
            <br />
            <div className="mx-5 col-md-6">
              <h5>
                <strong>Day and Time Registered</strong>:
                {new Date(applicant.DateRegistered).toDateString()}
              </h5>
            </div>
            <div>
              <div className="mb-4 mx-5">
                <div className="col-md-4">
                  <h3
                    className="p-2 text-center"
                    style={{
                      fontSize: "1.5em",
                      fontWeight: "bold",
                      borderRadius: "6px",
                      backgroundColor: "#f9af16",
                      color: "white",
                    }}
                  >
                    BASIC DETAILS
                  </h3>
                </div>
              </div>
              <div className="row mx-5">
                <div className="col-md-4">
                  <div className="text-center">
                    {/* <p className="mb-1 mt-3 mx-3 font-weight-bold">Passport</p> */}
                    <img
                      className="img-fluid offset-2 border"
                      src={
                        applicant.Passport != null
                          ? applicant.Passport
                          : "https://unicrossdoc.blob.core.windows.net/passport/Avatar.jpg"
                      }
                      alt=""
                      style={{ maxWidth: "200px", maxHeight: "200px" }}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-4">
                      <p className="mb-1 mt-3 font-weight-bold">Jamb Reg No</p>
                      {applicant.JambRegNo}
                    </div>
                    <div className="col-md-4">
                      <p className="mb-1 mt-3 font-weight-bold">
                        Department Category
                      </p>
                      {applicant.Applicant.CategoryName}
                    </div>
                    <div className="col-md-4">
                      <p className="mb-1 mt-3 font-weight-bold">Department</p>
                      {applicant.Applicant.DepartmentName}
                    </div>
                    <div className="col-md-6  col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">First Name</p>
                      {applicant.FirstName}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Other Name</p>
                      {applicant.OtherName}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Last Name</p>
                      {applicant.LastName}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Email</p>
                      {applicant.Email}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">
                        Date of Birth
                      </p>
                      {handleDobValue(applicant.DateOfBirth)}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Gender</p>
                      {applicant.Gender}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Phone Number</p>
                      {applicant.PhoneNumber}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">
                        Marital Status
                      </p>
                      {applicant.Applicant.MaritalStatusName}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Address</p>
                      {applicant.Address}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">Country</p>
                      {applicant.Applicant.CountryName}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">State</p>
                      {applicant.Applicant.StateName}
                    </div>
                    <div className="col-md-6 col-lg-4 border-bottom ">
                      <p className="mb-1 mt-3 font-weight-bold">LGA</p>
                      {applicant.Applicant.LGAName}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* UTME Section */}

          {/* Olevel Section */}
          <div className="container-fluid pt-2 mb-5">
            <div className="row mx-5">
              <div className="col">
                <div className="row">
                  <div className="col-lg-4">
                    <h3
                      className="p-2 text-center"
                      style={{
                        fontSize: "1.5em",
                        fontWeight: "bold",
                        borderRadius: "6px",
                        backgroundColor: "#f9af16",
                        color: "white",
                      }}
                    >
                      O'LEVEL RESULT
                    </h3>
                  </div>
                </div>

                <table id="documentAppForm" className="border">
                  <thead>
                    <tr>
                      <th>Exam Number</th>
                      <th>Year of Exam</th>
                      <th>Type</th>
                      <th>Subject</th>
                      <th>Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {olevel
                      ? olevel.map((o, i) => (
                          <tr key={i}>
                            <td>{o.ExamNumber}</td>
                            <td>{o.ExamYear}</td>
                            <td>{o.OLevelTypeName}</td>
                            <td>{o.OLevelSubjectName}</td>
                            <td>{o.GradeName}</td>
                          </tr>
                        ))
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default ApplicantForm;
